// ----------------------------------------------------------------------------
// Nombre del Programa : DetalleEnlace
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el detalle de los enlaces
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './DetalleEnlace.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileUploader } from 'react-drag-drop-files';
import { StatusAlertService } from 'react-status-alert';
import { EnlacesProps } from '../../interfaces/enlacesInterfaces';
import { getEnlace, postEnlace } from '../../Services/EnlacesService';
import { postAdjunto } from '../../Services/AdjuntosService';
import { getImgMB } from '../../Utilidades/session';

export const DetalleEnlace = () => {
  const fileTypes = ['JPG', 'JPEG', 'PNG', 'GIF'];
  const [tituloAdjunto, setTituloAdjunto] = useState(
    'Seleccione/Arrastre Imagen'
  );
  const [nombreEnlace, setNombreEnlace] = useState('');
  const [nombreBolsa, setNombreBolsa] = useState('');
  const [enlaceid, setEnlaceId] = useState(0);
  const [urlImagen, setUrlImagen] = useState('');
  const [principal, setPrincipal] = useState<boolean>(false);
  const [orden, SetOrden] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      let _state = location.state as any;
      setPrincipal(_state.principal);
      setEnlaceId(_state.idenlace);
      if (_state.idenlace !== 0) {
        cargarEnlace(_state.idenlace);
      }
    }
  }, []);

  const cargarEnlace = async (id: Number) => {
    const response: any = await getEnlace(id).catch(({ response }) => {
      const { data } = response;
      //const noEnlaces: EnlacesProps[] = [];
      //setEnlaces(noEnlaces);
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      //setEnlaces(response.data.data);
      setNombreEnlace(response.data.data[0].urlEnlace);
      setNombreBolsa(response.data.data[0].nombre);
      SetOrden(response.data.data[0].orden);
      setUrlImagen(response.data.data[0].urlImagen);
    }
  };

  const guardarEnlace = async () => {
    if (nombreBolsa === '') {
      StatusAlertService.showError('Ingrese el nombre del enlace');
      return;
    }
    if (nombreEnlace === '') {
      StatusAlertService.showError('Ingrese el enlace');
      return;
    }
    if (urlImagen === '') {
      StatusAlertService.showError('Agregue la imagen');
      return;
    }

    const enlacesGuardar: EnlacesProps[] = [];
    let enlace = {} as EnlacesProps;
    enlace.enlace_id = enlaceid;
    enlace.nombre = nombreBolsa;
    enlace.urlEnlace = nombreEnlace;
    enlace.urlImagen = urlImagen;
    enlace.principal = principal;
    enlace.orden = orden;

    enlacesGuardar.push(enlace);

    const response: any = await postEnlace(enlacesGuardar).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      navigate(-1);
    }
  };

  const guardarImagen = async (file: any) => {
    //setCargado(false);
    let formData = new FormData();
    formData.append('file', file);
    const response: any = await postAdjunto(formData).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data) {
      //console.log('data:', response.data);
      let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
      setUrlImagen(downloadUri);
    }
  };

  const handleChangeImagen = (file: any) => {
    //setFile(file);
    setTituloAdjunto('Seleccionar/Arrastrar Otra');
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      //console.log('Result: ', reader.result);
      guardarImagen(file);
      //setImagenCargada(reader.result! as string)
    };
    reader.onerror = function (error) {
      setUrlImagen('');
      StatusAlertService.showError('Ocurrio un error al cargar el archivo...');
    };
    //console.log('file:', file);
  };
  const onSizeErrorImagen = (file: any) => {
    setUrlImagen('');
    StatusAlertService.showError(
      `El tamaño del archivo debe ser menor a ${getImgMB()} mb...`
    );
  };
  const onTypeErrorImagen = (file: any) => {
    setUrlImagen('');
    StatusAlertService.showError(
      'El tipo de archivo que agrego no es valido...'
    );
  };

  const enterTexto = (target: any) => {
    if (target.key === 'Enter') {
      target.preventDefault();
    }
  };

  return (
    <>
      <div className="m-5">
        <Row className="mb-2">
          <Col className="heading-1">Enlaces {'>'} Agregar enlace</Col>
        </Row>
        <Row className="mt-3 agregar-enlace">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">Nuevo enlace</Col>
            </Row>
            <Row className="mt-3">
              <Col sm={6} className="minimocolumna">
                <Form.Label className="textorojoprimary">
                  Medidas recomendadas: 600*240 px
                </Form.Label>
                <FileUploader
                  label="Seleccione o arrastre imagen"
                  hoverTitle="Suelte aqui!"
                  maxSize={getImgMB()}
                  children={
                    <div className="adjuntar-enlace">
                      {urlImagen != '' ? (
                        <img src={urlImagen} />
                      ) : (
                        <div className="info-adjuntarenlace">
                          <span className="titulo">{tituloAdjunto}</span>
                        </div>
                      )}
                    </div>
                  }
                  handleChange={handleChangeImagen}
                  onTypeError={onTypeErrorImagen}
                  onSizeError={onSizeErrorImagen}
                  name="file"
                  types={fileTypes}
                />
              </Col>
              <Col sm={4} className="minimocolumna">
                <Form className="d-flex bolsatrabajo">
                  <Form.Control
                    type="search"
                    className="borde-rojo mt-3 mb-2"
                    placeholder="Nombre del enlace."
                    maxLength={100}
                    value={nombreBolsa}
                    onChange={(e) => setNombreBolsa(e.target.value)}
                    onKeyPress={enterTexto}
                  />
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12}>
                <label></label>
                <Form className="d-flex">
                  <InputGroup.Text className="material-icons icono-enlace borde-rojo">
                    link
                  </InputGroup.Text>
                  <Form.Control
                    type="search"
                    className="texto-enlace borde-rojo"
                    placeholder="Agregar enlace."
                    maxLength={2000}
                    value={nombreEnlace}
                    onChange={(e) => setNombreEnlace(e.target.value)}
                    onKeyPress={enterTexto}
                  />
                </Form>
              </Col>
            </Row>
            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button
                variant="primary"
                className="float-end"
                onClick={() => guardarEnlace()}
              >
                {enlaceid !== 0 ? 'Actualizar enlace' : 'Crear enlace'}
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
